import React, { useEffect } from "react";
import "../../../../../Assets/Styles/UserGuide.scss";

const JPATabsGuide = (props) => {
  useEffect(() => {
    document.getElementById("home-tabs").style.zIndex = 99999;

    document.getElementById("jpa-tabs-guide").scrollIntoView();

    return () => {
      if (document.getElementById("home-tabs")) {
        document.getElementById("home-tabs").style.zIndex = 0;
      }
    };
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const toggleNextGuide = () => {
    props.ToggleNextDialog();
  };

  const togglePrevGuide = () => {
    props.TogglePreviousDialog();
  };

  return (
    <div className="guide-dialog jpa-tabs-guide" id="jpa-tabs-guide">
      <i className="feather-x" onClick={() => props.CloseGuide()}></i>
      <p className="dialog-text">
        {translateText("walkthrough_homepage_jpa_tabs")}
      </p>
      <section className="dialog-footer">
        <div
          className="steps-navs back"
          onClick={() => togglePrevGuide()}
          style={
            !props.GuideHasAdditionalStep
              ? { opacity: "0", pointerEvents: "none" }
              : null
          }
        >
          <i className="feather-arrow-left"></i>
          <p>{translateText("back")}</p>
        </div>
        <div className="indicators">
          <>
            {props.GuideHasAdditionalStep ? (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(i)}
                    className={
                      i === 1 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i)}
                  ></span>
                ))}
              </>
            ) : (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(Item)}
                    className={
                      i === 0 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i + 1)}
                  ></span>
                ))}
              </>
            )}
          </>
        </div>
        <div className="steps-navs next" onClick={() => toggleNextGuide()}>
          <p>{translateText("next")}</p>
          <i className="feather-arrow-right"></i>
        </div>
      </section>
    </div>
  );
};

export default JPATabsGuide;
